import React, { Fragment } from 'react';
import CheckboxField from '../components/CheckboxField';


const LysingMap = {
    "Sveitarstjórnarkosninga": "Sveitarstjórnarkosningar",
    "Forsetakosning": "Forsetakjör"
}

const Header = props => {
  const { kjosandi, activeKosning } = props;

  // Annoying manipulation to accomodate requirements
  // from Reykjavik to show norður/suður depending on kjordæmi.
  // kjördæmi = 1 => suður
  // kjördæmi = 2 => norður
  const getDisplayFormatForSveitarfelag = () => {
    if (kjosandi.numerKjordaemis === 5) {
      return `${kjosandi.sveitarfelag} suður`;
    } else if (kjosandi.numerKjordaemis === 6) {
      return `${kjosandi.sveitarfelag} norður`;
    } else {
      return kjosandi.sveitarfelag;
    }
    };


  return (
    <Fragment>
        {/*<div style={{ display: "flex" }}>*/}
        {/*  <div>*/}
        {/*    <h3>{activeKosning.lysing}</h3>*/}
        {/*  </div>*/}
        {/*</div>*/}
          <div style={{ display: "flex" }}>
              <div>
                    <div style={{ textTransform: "uppercase", fontWeight: "bold", color: "#666" }}>
                        <h1 style={{ margin: 0, fontSize: "2.2em"  }}>Fylgibréf með kjörseðli</h1>
                        <span style={{ fontSize: "1.25em", letterSpacing: "1px" }}>Við atkvæðagreiðslu utan kjörfundar</span>
                    </div>
                    <div style={{ display: "flex", marginTop: "2rem" }}>
                        <label style={{ display: "inline-block", whiteSpace: "nowrap", marginRight: 5 }} htmlFor="kjorstjorn">Til kjörstjórnar í/á: </label>
                        <div>
                            <input
                                id="kjorstjorn"
                                name="kjorstjorn"
                                type="text"
                                defaultValue={getDisplayFormatForSveitarfelag()}
                              style={{
                                  borderTop: "none",
                                  borderRight: "none",
                                  borderLeft: "none",
                                  borderBottom: "1px solid black",
                                  width: "100%",
                                  fontWeight: 'bold',
                                  margin: "-3px 0px 5px"
                              }}
                            />
                            <p style={{ fontSize: 10, fontWeight: "bold" }}>Fylgibréfið skal áritað til kjörstjórnar þess sveitarfélags sem kjósandi telur sig vera á kjörskrá í.</p>
                            <p style={{ fontSize: 10, fontWeight: "bold" }}>Ef kjósandi er ekki skráður með lögheimili á Íslandi, skal fylgibréfið áritað til kjörstjórnar í því sveitarfélagi þar sem hann átti síðast lögheimili á Íslandi og atkvæðabréfið sent þangað.</p>
                        </div>
                    </div>
              </div>
              <h3 style={{ marginLeft: 25, fontWeight: "bold" }}>
                {activeKosning.tegundLysing === "Sveitarstjórnarkosninga" ? "Sveitarstjórnarkosningar" : activeKosning.tegundLysing === "Forsetakosning" ? "Forsetakjör" : activeKosning.tegundLysing}
            </h3>
        </div>
    </Fragment>
    )
}

export default Header;


//<div style={{ display: "flex" }}>
//    <div>
//        <h3>{activeKosning.lysing}</h3>
//    </div>
//</div>
